// Mount the Waf module: build its host from what only this app can supply and hand it to
// `createWafModule`. `service-modules.ts` and `service-scopes.ts` take the routes and the catalog
// scope from HERE, so the module cannot be mounted unregistered. The HTTP client is not a member:
// the module reads it from the shared registry (`@vnetwork/margarita-core/http`).
import { createWafModule } from '@vnetwork/margarita-waf';
import { withHostBase } from './host-base';

export const waf = createWafModule(withHostBase(['trackFeatureAction', 'categoryBackTarget'], {}));
